/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/granby-easy-guide-icon-white': {
    width: 38,
    height: 48,
    viewBox: '0 0 38 48',
    data: '<path pid="0" d="M17.022 9.276A4.64 4.64 0 1017.02.002a4.64 4.64 0 00.003 9.274zM24.19 35.558c-1.233 4.28-5.178 7.422-9.85 7.422-5.655 0-10.255-4.6-10.255-10.255 0-4.185 2.525-7.788 6.129-9.38v-4.348C4.312 20.775 0 26.253 0 32.725c0 7.907 6.433 14.34 14.34 14.34 5.764 0 10.73-3.425 13.008-8.339l-1.62-3.181-1.539.013z" _fill="#fff"/><path pid="1" d="M37.702 41.063L31.49 28.85a2.72 2.72 0 00-2.427-1.49h-7.956v-1.814h6.848c.683 0 1.258-.357 1.63-.872.24-.335.412-.725.412-1.17a2.042 2.042 0 00-2.043-2.043H21.108v-6.154c0-1.693-1.255-4.085-4.084-4.085a4.085 4.085 0 00-4.085 4.085V28.64a4.167 4.167 0 004.167 4.167h10.289l5.455 10.726a2.721 2.721 0 003.661 1.193 2.72 2.72 0 001.192-3.663z" _fill="#fff"/>'
  }
})
